module.exports = __webpack_public_path__ + "img/default-google-map-navy.93219b5f.png";